import { colors } from '@pets-ui/tokens/colors.stylex'
import * as stylex from '@stylexjs/stylex'

const styles = stylex.create({
  badge: {
    borderRadius: '20px',
    paddingInline: '4px',
    alignItems: 'center',
    color: colors.white,
    display: 'flex',
    fontSize: '10px',
    fontWeight: 'bold',
    justifyContent: 'center',
    height: 16,
    minWidth: 16,
  },
  bgColor: (backgroundColor: string) => ({ backgroundColor }),
})

interface MemberCouponBadgeCountProps {
  couponCount: number
  menuBadgeBgColor: string
  testId?: string
}

export const MemberCouponBadgeCount = ({ couponCount, menuBadgeBgColor, testId }: MemberCouponBadgeCountProps) => {
  if (couponCount <= 0) return null

  const displayCount = couponCount > 99 ? '99+' : String(couponCount)

  return (
    <div data-testid={testId} {...stylex.props(styles.badge, styles.bgColor(menuBadgeBgColor))}>
      {displayCount}
    </div>
  )
}
